<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title class="font-weight-normal">
        Safest traders by drawdown
      </b-card-title>
    </b-card-header>
    <b-card-body>
      <template v-if="loading">
        <div
            v-for="i in 5"
            :key="i"
            class="employee-task d-flex justify-content-between align-items-center  "
        >
          <b-media no-body>
            <b-media-aside class="mr-75">
              <b-skeleton width="40px" height="40px" class="rounded-circle" />
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0">
                <b-skeleton width="100px" height="20px" />
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <b-skeleton width="80px" height="20px" />
          </div>
        </div>
      </template>
      <template v-else-if="safestTraders.length">
        <div
            v-for="(safestTrader, index) in safestTraders"
            :key="index"
            class="employee-task d-flex justify-content-between align-items-center  "
        >
          <b-media no-body>
            <b-media-aside class="mr-75">
              <b-avatar
                  size="42"
                  :src="safestTrader.avatar"
                  class="rounded-avatar"
                  style="border: 2px solid #4D556D;"
              />
            </b-media-aside>
            <b-media-body class="my-auto">
              <h6 class="mb-0">
                {{ safestTrader.full_name }}
              </h6>
            </b-media-body>
          </b-media>
          <div class="d-flex align-items-center">
            <span class="h6   mr-75 text-red"
            >{{ safestTrader.mdd ? safestTrader.mdd.toFixed(2) : 0 }}%</span
            >
          </div>
        </div>
      </template>
      <template v-else>
        <div
          class="d-flex align-items-center justify-content-center h-100 new-alert"
        >
          <b-alert
            show
            variant="secondary"
            class="d-flex align-items-center justify-content-center p-3 w-100"
          >
            no information
          </b-alert>
        </div>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BMedia,
  BAvatar,
  BMediaBody,
  BMediaAside,
  BCardBody,
  BCardTitle,
  BCardHeader,
  BImg,
  BSkeleton,
  BAlert,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    BCard,
    BMedia,
    BAvatar,
    BMediaBody,
    BMediaAside,
    BCardBody,
    BCardTitle,
    BCardHeader,
    VueApexCharts,
    BImg,
    BSkeleton,
    BAlert,
  },
  props: {
    analytics: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    analytics(val) {
      this.safestTraders = val.safest_traders;
    },
  },
  data() {
    return {
      safestTraders: [],
    };
  },
};
</script>

<style></style>
